import { all, put, select, takeEvery } from 'redux-saga/effects';
import { AudioChatActions } from './audioChatActions';
import { ScenarioChartStoreActions } from 'app/actions/scenarios/scenarioChartStoreAction';
import * as ScenarioChartSelectors from 'app/selectors/scenarioChartSelectors.ts';
import { AudioChatSelector } from '.';
import { ILink } from '@mrblenny/react-flow-chart';


function* setCurrentNodeInDialog(action: ReturnType<typeof AudioChatActions.addCallerResponse>) {
  const { payload } = action;
  const blockId = payload?.audioResponse?.lastBlockId;
  if (!blockId) {
    return;
  }
  yield put(
    ScenarioChartStoreActions.setNodeProperty({
      id: blockId,
      propertyName: 'isDialogProcessOnTheNode',
      propertyValue: true,
      isUnique: true
    })
  );
}

function* resetCurrentNode() {
  const links: { [id: string]: ILink } = yield select(ScenarioChartSelectors.chartLinks);
  const blockHistory: number[] = yield select(AudioChatSelector.blockHistorySelector);
  const lastBlockId: number = yield select(AudioChatSelector.lastBlockIdSelector);
  if (!lastBlockId) {
    return;
  }
  const outgoingLinks = Object.values(links).map((l) => l.from.nodeId);
  if (outgoingLinks.includes(lastBlockId.toString())) {
    // Current block id has links to other blocks, so we keep the blinking animation on current block
    return;
  }
  // Find the last block id that has links to other blocks
  // If no last block with link found, the blinking animation will remain on the current block
  for (let i = blockHistory.length - 1; i >= 0; i--) {
    const blockId = blockHistory[i];
    if (outgoingLinks.includes(blockId.toString())) {
      yield put(
        ScenarioChartStoreActions.setNodeProperty({
          id: blockId,
          propertyName: 'isDialogProcessOnTheNode',
          propertyValue: true,
          isUnique: true
        })
      );
      return;
    }
  }
}

function* audioChatSaga() {
  yield all([
    takeEvery(AudioChatActions.addCallerResponse, setCurrentNodeInDialog),
    takeEvery(AudioChatActions.translatedSpeechFinished, resetCurrentNode),

  ]);
}
export default audioChatSaga;
